import React, { useState } from "react";
import Logo2 from "../../assets/images/Logo2.png";
import SetTitle from "../../components/SetTitle";
import styles from "./Franchise.module.scss";
import axiosInstance from "../../components/Hooks/axiosInstance";
import { toast } from "react-toastify";

const Franchise = () => {
	SetTitle("Franchise");

	const [name, setName] = useState("");
	const [email, setEmail] = useState("");
	const [number, setNumber] = useState("");
	const [message, setMessage] = useState("");

	const [uploading, setUploading] = useState(false);

	const handelSend = () => {
		if (!name || !email || !number || !message) {
			return toast.warn("Name, email, phone and message are required fields...");
		}
		
		setUploading(true);
		axiosInstance
			.post(`/franchise/create`, {
				name,
				email,
				phone: number,
				message,
			})
			.then(({ data }) => {
				toast.success(data?.msg || data?.message || "Franchise form submitted successfully. We will reach you soon ...");
				setName("");
				setEmail("");
				setMessage("");
				setNumber("");
			})
			.catch((err) => {
				console.log(err);
				toast.error(err?.response?.data?.msg || err?.response?.data?.message || "Something went wrong...");
			})
			.finally(() => setUploading(false));
	};

	return (
		<div className={styles.Franchise}>
			<h2>Franchise</h2>
			<h3>Franchise Opportunity // Partnering success</h3>
			<p>
				In order to start the Mine Kids preschool the first & basic requirement is that the partner should love kids and have a
				passion to do this business with a long term vision. We at Mine Kids believe that alliances are an integral part of
				contemporary strategic businesses. We always look out for good business partners who can share our vision, articulate it,
				passionately own our vision, and relentlessly drive it to completion.
			</p>
			<h3>About Mine Kids</h3>
			<p>
				The journey of Mine Kids began in 2018 with its first branch at Baramunda, Bhubaneswar. From then on, Mine Kids became the
				trendsetter for preschool education. Mine Kids remains the only preschool with a research and development department. All
				the teachers undergo rigorous training and are continuously educated about new revelations in child psychology.
			</p>
			<h3>About S D Group of Education</h3>
			<p>
				In order to start the Mine Kids preschool the first & basic requirement is that the partner should love kids and have a
				passion to do this business with a long term vision. We at Mine Kids believe that alliances are an integral part of
				contemporary strategic businesses. We always look out for good business partners who can share our vision, articulate it,
				passionately own our vision, and relentlessly drive it to completion.
			</p>
			<h3>Who Can Start</h3>
			<p>
				We are looking for partners who love kids and have a passion to do this business with a long-term vision. In order to
				start the Mine Kids school, the first and basic requirement is that the partner should love kids and have a passion to do
				this business with a long term vision. Along with that you should own an area between 1500 sq ft â€“ 10000 sq. ft. With an
				investment capacity ranging between Rs. 5 lakh to Rs. 15 lakh depending upon the area and location.
			</p>
			<h3>Why Mine Kids</h3>

			<ul>
				<li>One of the strongest brands of preschools with the maximum recall among parents</li>
				<li>Worldwide recognition. We are the only pre-school in India to have won a Gold Cannes.</li>
				<li>The only preschool with a research and development department to develop and update our child centric curriculum</li>
				<li>Focus on teacher training and recruiting of best talent</li>
			</ul>

			<div className={styles.PartnerContainer}>
				<img src={Logo2} alt="" />
				<h3>Partner with us</h3>
				<p>If you share our passion and want to be a part of our growth story, get in touch with us.</p>
				<div className={styles.FormContainer}>
					<div className={styles.InputContainer}>
						<label>Name</label>
						<input type="text" value={name} onChange={(e) => setName(e.target.value)} />
					</div>
					<div className={styles.InputContainer}>
						<label>Email</label>
						<input type="email" value={email} onChange={(e) => setEmail(e.target.value)} />
					</div>
					<div className={styles.InputContainer}>
						<label>Phone</label>
						<input type="number" value={number} onChange={(e) => setNumber(e.target.value)} />
					</div>
					<div className={styles.InputContainer}>
						<label>Message</label>
						<textarea value={message} onChange={(e) => setMessage(e.target.value)}></textarea>
					</div>
					{uploading ? <button style={{ cursor: "none" }}>Uploading...</button> : <button onClick={handelSend}>Send</button>}
				</div>
			</div>
		</div>
	);
};

export default Franchise;
